import { Component } from '@angular/core';
import { RouterOutlet,RouterModule,RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from "@anonymous/loader/loader.component";
@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, RouterModule, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent{
  title = 'AppBaseAngular';
  

  
}
